import { getInstanceByDom } from 'echarts';
import { download } from '../download';
import type { DownloadChartParams } from './types';

/**
 * 导出echarts为图片
 * @param params
 * @returns
 */
export async function downloadChart(params: DownloadChartParams): Promise<void> {
  const { fileName = 'chart.png', selectors } = params;
  const node: HTMLDivElement | null = document.querySelector(selectors);
  const chart = getInstanceByDom(node as HTMLDivElement);
  const dataURL = chart?.getDataURL({
    type: 'png',
    pixelRatio: 2,
    backgroundColor: '#fff',
    excludeComponents: ['dataZoom']
  });

  if (dataURL != null && dataURL?.length > 0) {
    await download({ type: 'img', url: dataURL, fileName });
  }
}
